import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './SystemLogs.css';

const SystemLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedLog, setSelectedLog] = useState('shipments');
  const [lines, setLines] = useState(100);
  const [autoRefresh, setAutoRefresh] = useState(false);

  useEffect(() => {
    fetchLogs();
  }, [selectedLog, lines]);

  useEffect(() => {
    let interval;
    if (autoRefresh) {
      interval = setInterval(() => {
        fetchLogs();
      }, 5000); // Refresh every 5 seconds
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [autoRefresh, selectedLog, lines]);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get(`/monitoring/system-logs?log_file=${selectedLog}&lines=${lines}`);
      setLogs(response.data.logs || []);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch system logs');
    } finally {
      setLoading(false);
    }
  };

  const getLogLevelClass = (line) => {
    if (line.includes('ERROR')) return 'log-error';
    if (line.includes('WARNING')) return 'log-warning';
    if (line.includes('INFO')) return 'log-info';
    return '';
  };

  return (
    <div className="system-logs">
      <div className="logs-controls">
        <div className="control-group">
          <label>Log File:</label>
          <select value={selectedLog} onChange={(e) => setSelectedLog(e.target.value)}>
            <option value="shipments">Shipments</option>
            <option value="auth">Authentication</option>
            <option value="upload">File Uploads</option>
            <option value="admin">Admin Actions</option>
          </select>
        </div>

        <div className="control-group">
          <label>Lines:</label>
          <select value={lines} onChange={(e) => setLines(parseInt(e.target.value))}>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
          </select>
        </div>

        <div className="control-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={autoRefresh}
              onChange={(e) => setAutoRefresh(e.target.checked)}
            />
            Auto-refresh (5s)
          </label>
        </div>

        <button className="btn-refresh" onClick={fetchLogs}>
          🔄 Refresh
        </button>
      </div>

      {loading && <div className="loading-message">Loading logs...</div>}
      {error && <div className="error-message">{error}</div>}

      {!loading && !error && logs.length === 0 && (
        <div className="no-data-message">No logs found</div>
      )}

      {!loading && !error && logs.length > 0 && (
        <div className="logs-viewer">
          <div className="logs-header">
            <span>Showing last {logs.length} lines from {selectedLog}.log</span>
          </div>
          <pre className="logs-content">
            {logs.map((line, index) => (
              <div key={index} className={`log-line ${getLogLevelClass(line)}`}>
                {line}
              </div>
            ))}
          </pre>
        </div>
      )}
    </div>
  );
};

export default SystemLogs;
